import { createSlice } from '@reduxjs/toolkit';
import { moderateText } from './thunks/commonInfoThunks';

const moderationSlice = createSlice({
    name: 'moderation',
    initialState: {
        moderatingFields: {},
        errors: {},
    },
    reducers: {
        clearModerationError: (state, action) => {
            const { fieldName } = action.payload;
            delete state.errors[fieldName];
        },
        clearAllModerationErrors: (state) => {
            state.errors = {};
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(moderateText.pending, (state, action) => {
                const { fieldName } = action.meta.arg;
                state.moderatingFields[fieldName] = true;
                delete state.errors[fieldName];
            })
            .addCase(moderateText.fulfilled, (state, action) => {
                const { fieldName, flagged, reason } = action.payload;
                state.moderatingFields[fieldName] = false;

                if (flagged) {
                    state.errors[fieldName] = reason;
                }
            })
            .addCase(moderateText.rejected, (state, action) => {
                const { fieldName } = action.meta.arg;
                state.moderatingFields[fieldName] = false;
                console.error(`Moderation API error for ${fieldName}`);
            });
    },
});

export const { clearModerationError, clearAllModerationErrors } = moderationSlice.actions;

export const moderate = moderationSlice.reducer;

export const selectIsModerating = (state, fieldName) =>
    state.moderate?.moderatingFields[fieldName] || false;

export const selectModerationError = (state, fieldName) =>
    state.moderate?.errors[fieldName];